<template>
  <div class="step-space">
    <el-steps :active="active" align-center>
      <el-step
        :title="item.name"
        v-for="(item, index) in statusSteps"
        :key="index"
      >
        <template #icon>
          <el-popover placement="top" width="200" trigger="hover" content="1">
            <div class="pop-content">
              <div class="pop-content-top">
                <div class="pop-name">{{ item.creatorName || "--" }}</div>
                <div class="pop-name pop-status">
                  <div class="deal-status" v-if="index < active"></div>
                  <div class="" v-else-if="index == active"></div>
                  <div
                    class="deal-status"
                    style="background-color: #c9cdd4"
                    v-else
                  ></div>
                  <div class="" v-if="index < active">已处理</div>
                  <div class="" v-else-if="index == active"></div>
                  <div class="" v-else>未响应</div>
                </div>
              </div>
              <div class="pop-content-bottom">
                耗时：{{ item.dealTime || "--" }}
              </div>
            </div>
            <template #reference>
              <div class="cus-icon">
                <img
                  v-if="index < active"
                  style="width: 16px"
                  src="../../../assets/images/check@2x.png"
                />
                <span
                  v-else
                  class="num"
                  style="font-weight: 600; font-size: 16px"
                  >{{ index + 1 }}</span
                >
              </div>
            </template>
          </el-popover>
        </template>
        <template #description>
          <div>
            <div>
              {{ item.creatorName }}
            </div>
            <div>{{ item.createdAt }}</div>
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { getCurrentUser, getDictMap } from "@/utils/util";
import dayjs from "dayjs";
export default {
  name: "afterSaleStep",
  props: {
    afterSaleOrder: {
      type: Object,
    },
  },
  data() {
    return {
      statusSteps: [],
      active: 0,
      dmap: {},
      currentUser: {},
      lastCodes: [
        {
          check: ["pre_inspection_of_receiving_goods", "pending_review"], //收货预检，待审核
          values: ["to_be_returned", "returned"], //待退回，已退回
        },
        {
          check: ["pre_inspection_of_receiving_goods"], //收货预检
          values: ["returned_inventory"], //已退货
        },
      ],
      steps: [
        {
          codes: ["submit_after_sales"], //提交售后单
        },
        {
          codes: ["pre_inspection_of_receiving_goods"], //收货预检
        },
        {
          codes: ["pending_review"], //待审核
        },
        {
          codes: ["under_repair"], //维修中
        },
        {
          codes: ["to_be_sent_out", "sent_out"], //待寄回，已寄回,
        },
      ],
      endCodes: ["sent_out", "returned", "returned_inventory", "cancelled"], //已寄回，已退回
    };
  },
  watch: {
    afterSaleOrder(newval) {
      this.updateStatus(newval);
    },
  },
  mounted() {
    this.dmap = getDictMap();
    this.currentUser = getCurrentUser();

    this.updateStatus(this.afterSaleOrder);
  },
  methods: {
    updateStatus(data) {
      console.log("afterSaleStep:-------------------", data);

      this.active = 0;
      if (!data?.id) {
        this.statusSteps = this.steps.map((step) => ({
          ...step,
          name: this.dmap[step.codes[0]]?.name,
        }));
        return;
      }

      const currentStatus = this.dmap[data?.status];

      const statusMap = {};
      const slogs = data?.statusLog || [];
      slogs.forEach((l, i) => {
        const f = this.dmap[l.statusFrom];
        const t = this.dmap[l.statusTo];
        let dealTime;
        if (i > 0) {
          const prev = slogs[i - 1];
          dealTime = this.calTime(prev.createdAt, l.createdAt);
        }
        console.log(f.name, t.name, l.createdAt);
        statusMap[f.code] = { name: f.name, toCode: t.code, dealTime, ...l };
        if (this.endCodes.includes(t.code)) {
          statusMap[t.code] = { name: t.name, ...l };
        }
      });

      //已取消
      if (currentStatus?.code === "cancelled") {
        this.statusSteps = this.steps.map((step, i) => {
          let name = this.dmap[step.codes[0]]?.name;
          let creatorName, createdAt, dealTime;
          if (i === 0) {
            name = currentStatus?.name;
            const statusM = statusMap[currentStatus?.code];
            creatorName = statusM?.creatorName;
            createdAt = statusM?.createdAt;
            dealTime = statusM?.dealTime;
          }
          return {
            ...step,
            name,
            creatorName,
            createdAt,
            dealTime,
          };
        });
        return;
      }

      const { values: lCodes } =
        this.lastCodes.find(({ check, values }) => {
          return check.some((c) => values.includes(statusMap[c]?.toCode));
        }) || {};

      const cSteps = this.steps
        .map((step, i) => {
          return {
            ...step,
            codes: i === this.steps.length - 1 && lCodes ? lCodes : step.codes,
          };
        })
        .map((step) => {
          const sname = this.dmap[step.codes[0]]?.name;
          step.codes.forEach((code) => {
            const lg = statusMap[code];
            if (lg) {
              step.name = lg?.name || sname;
              step.creatorName = lg?.creatorName;
              step.createdAt = lg?.createdAt;
              step.dealTime = lg?.dealTime;
              if (code === "pending_review") {
                if (lg.toCode === "to_be_sent_out") {
                  step.name = "审核通过";
                } else {
                  step.name = "审核拒绝";
                }
              }
            } else {
              step.name = sname;
            }
          });
          return step;
        });

      this.active = cSteps.findIndex((v) =>
        v.codes.includes(currentStatus?.code)
      );

      const currentStep = cSteps[this.active];
      if (currentStep) {
        if (!currentStep.creatorName && !currentStep?.createdAt) {
          currentStep.name = currentStatus?.name;
          //currentStep.creatorName = this.currentUser.realName;
        } else {
          currentStep.finished = true;
        }
      }

      //补齐空流程
      for (let i = this.active - 1; i >= 0; i--) {
        const e = cSteps[i];
        const next = cSteps[i + 1];
        e.finished = true;
        if (!e.creatorName && !e.createdAt) {
          e.creatorName = "自动完成";
          e.createdAt = next.createdAt
            ? next.createdAt
            : dayjs().format("YYYY-MM-DD HH:mm:ss");
        }
        currentStep.finished = true;
      }

      this.statusSteps = cSteps;
    },

    calTime(startTime, endTime) {
      //计算时间差值
      const start = dayjs(startTime);
      const end = dayjs(endTime);

      // 计算差值（以毫秒为单位）
      const diffInMilliseconds = end.diff(start);

      // 将毫秒转换为小时和分钟
      const duration = dayjs.duration(diffInMilliseconds);
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      // 返回时间差字符串
      // console.log("时间差字符串", `${hours}小时${minutes}分钟`);
      return `${hours}小时${minutes}分钟`;
    },
  },
};
</script>

<style lang="less" scoped>
.pop-content {
  .pop-content-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .pop-name {
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
    }
  }
  .pop-content-bottom {
    font-weight: 400;
    font-size: 12px;
    color: #86909c;
  }
}
.pop-status {
  display: flex;
  align-items: center;
}
.deal-status {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #00b42a;
  margin-right: 8px;
}
.cus-icon {
  display: flex;
  align-items: center;
  img {
    vertical-align: middle;
  }
}
</style>
